import { SvgProps } from "components/icons/types";

export const Document = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.7">
      <path
        d="M17.9999 20H5.99992C5.82311 20 5.65354 19.9298 5.52851 19.8047C5.40349 19.6797 5.33325 19.5101 5.33325 19.3333V4.66667C5.33325 4.48986 5.40349 4.32029 5.52851 4.19526C5.65354 4.07024 5.82311 4 5.99992 4H13.9999L18.6666 8.66667V19.3333C18.6666 19.5101 18.5963 19.6797 18.4713 19.8047C18.3463 19.9298 18.1767 20 17.9999 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9995 4V8.66667H18.6662"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33325 12.6665H14.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33325 15.333H14.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
